const TRUSTED_HOSTS: (string | RegExp)[] = [
  'localhost',
  /\.cowbellcyber\.ai$/,
  /\.morecowbell\.ai$/,
  /\.meetmoo\.ai$/,
  /\.cowbell\.au$/,
  /\.cowbellcyber\.co\.uk$/,
];

export function getValidatedOAuthRedirect(): string | null {
  const raw =
    new URLSearchParams(window.location.search).get('oauth_redirect') ||
    sessionStorage.getItem('mcp_oauth_redirect');
  if (!raw) return null;
  try {
    const url = new URL(raw);
    if (url.protocol !== 'https:' && url.protocol !== 'http:') return null;
    const isTrusted = TRUSTED_HOSTS.some((host) =>
      host instanceof RegExp ? host.test(url.hostname) : url.hostname === host
    );
    return isTrusted ? raw : null;
  } catch {
    return null;
  }
}

export function consumeOAuthRedirect(): string | null {
  const redirect = getValidatedOAuthRedirect();
  if (redirect) {
    sessionStorage.removeItem('mcp_oauth_redirect');
  }
  return redirect;
}
